export default __webpack_public_path__ + "static/media/in.5d59432a.svg";